import { DeviceIdentifierTypeEnum } from './PublicRequestReturnLabel.types'

export const IDENTIFIER_TYPE_OPTIONS = [
  {
    labelId: 'PublicRequestReturnLabel_deviceIdentifier_typeImei',
    type: DeviceIdentifierTypeEnum.IMEI,
  },
  {
    labelId: 'PublicRequestReturnLabel_deviceIdentifier_typeOrderId',
    type: DeviceIdentifierTypeEnum.ORDER_ID,
  },
  {
    labelId: 'PublicRequestReturnLabel_deviceIdentifier_typeReturnCaseId',
    type: DeviceIdentifierTypeEnum.RETURN_CASE_ID,
  },
]

export const PLACEHOLDER_MAP: Record<DeviceIdentifierTypeEnum, string> = {
  [DeviceIdentifierTypeEnum.IMEI]:
    'PublicRequestReturnLabel_deviceIdentifier_placeholderImei',
  [DeviceIdentifierTypeEnum.ORDER_ID]:
    'PublicRequestReturnLabel_deviceIdentifier_placeholderOrderId',
  [DeviceIdentifierTypeEnum.RETURN_CASE_ID]:
    'PublicRequestReturnLabel_deviceIdentifier_placeholderReturnCaseId',
}

export const ENTER_LABEL_MAP: Record<DeviceIdentifierTypeEnum, string> = {
  [DeviceIdentifierTypeEnum.IMEI]:
    'PublicRequestReturnLabel_deviceIdentifier_enterImei',
  [DeviceIdentifierTypeEnum.ORDER_ID]:
    'PublicRequestReturnLabel_deviceIdentifier_enterOrderId',
  [DeviceIdentifierTypeEnum.RETURN_CASE_ID]:
    'PublicRequestReturnLabel_deviceIdentifier_enterReturnCaseId',
}

export const EVERPHONE_HOME_URL = 'https://everphone.com'

export const MAX_DEVICES = 10

export const DEFAULT_DEVICE = {
  identifierType: DeviceIdentifierTypeEnum.IMEI,
  value: '',
}

// TODO: remove when real API provides tracking number
export const MOCK_TRACKING_NUMBER = 'TRNR-CWN5QUB-715472'
